import {groupRiskStatus} from '../../../util/uiconstants';

import selectComponentAccounts from './selectComponentAccounts';
import selectComponentRisks from './selectComponentRisks';

const filterIt = ({groupRiskStatusId}) =>
	groupRiskStatusId === groupRiskStatus.unmapped || groupRiskStatusId === groupRiskStatus.mapped;

export default (entityType) => {
	let list = null;
	if (entityType === 'account') list = selectComponentAccounts();
	if (entityType === 'risk') list = selectComponentRisks();

	return list.filter(filterIt);
};
